import { Component, input, OnInit } from '@angular/core';

@Component({
  selector: 'app-client-stats-enrollments',
  standalone: false,
  template: '<p>Enrollments stats</p>',
})
export class ClientStatsEnrollmentsComponent implements OnInit {
  key = input.required<string>();
  params = input<Record<string, any> | undefined>();

  ngOnInit(): void {}
}
